import { endpoint } from "_common/constants/common";
import api from "states/drivers";

const UserFundEndpoint = `${endpoint}/user-fund`;

export const UserFundApi = {
  getList: async ({ params }) =>
    await api
      .get(`${UserFundEndpoint}/list`, params)
      .then((result) => result.data?.data),
  getDetail: async ({ params }) =>
    await api
      .get(`${UserFundEndpoint}/detail`, params)
      .then((result) => result.data?.data),
  create: async ({ params }) =>
    await api
      .post(`${UserFundEndpoint}/create`, params)
      .then((result) => result.data),
  update: async ({ id, params }) =>
    await api
      .put(`${UserFundEndpoint}/update/${id}`, params)
      .then((result) => result.data),
  delete: async ({ id }) =>
    await api
      .delete(`${UserFundEndpoint}/delete/${id}`)
      .then((result) => result.data),
};
